import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { GripVertical } from "lucide-react";
import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface SortableHouseDeviceRowProps {
  id: string;
  disabled: boolean;
  dragHandleLabel: string;
  className: string;
  children: ReactNode;
}

/** Sortable list row with a drag handle (host device list). */
export function SortableHouseDeviceRow({
  id,
  disabled,
  dragHandleLabel,
  className,
  children,
}: SortableHouseDeviceRowProps) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id, disabled });

  return (
    <li
      ref={setNodeRef}
      style={{
        transform: CSS.Transform.toString(transform),
        transition,
      }}
      className={cn(
        className,
        isDragging && "relative z-10 bg-surface-0 shadow-md ring-2 ring-primary-200",
      )}
    >
      <button
        type="button"
        className={cn(
          "shrink-0 touch-none rounded-lg p-1.5 text-surface-400",
          disabled
            ? "cursor-default opacity-40"
            : "cursor-grab hover:bg-surface-100 hover:text-surface-700 active:cursor-grabbing",
        )}
        aria-label={dragHandleLabel}
        disabled={disabled}
        {...attributes}
        {...listeners}
      >
        <GripVertical className="h-4 w-4" aria-hidden />
      </button>
      {children}
    </li>
  );
}
